import React from 'react';
import GridForm from "./GridForm";
import {useSelector} from "react-redux";

const Grid = () => {
    const {userLanguage} = useSelector(state => state.app);
    return (
        <div>
            <GridForm
                userLanguage={userLanguage}
            />
        </div>
    )
}
export default Grid;